import { createAction } from '@reduxjs/toolkit';

export const fetchArticles = createAction('articles/fetchArticles');
export const fetchArticle = createAction('articles/fetchArticle', (articleId) => ({ payload: { articleId } }));
export const setArticlesSuccess = createAction('articles/setArticlesSuccess');
export const setArticleSuccess = createAction('articles/setArticleSuccess');
export const setArticlesError = createAction('articles/setArticlesError');
